import { useCallback } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import request from "project-config/services/request/request";
import { useSubAccountStore } from "@/store/SubAccountStore";

/**
 * 备注保存工作流：调用 remarkSubUser 持久化 remark，成功后刷新对应列表。
 * 子账号列表与钉钉子账号列表共用同一接口，仅刷新来源不同。
 */
export function useSaveRemark({
  isDingTalk,
  deptId,
}: {
  isDingTalk?: boolean;
  deptId?: number;
}) {
  const { fetchSubAccountList, fetchDingTalkSubAccountList, isSearchSubUser } =
    useSubAccountStore();
  const { t: errorT } = useTranslation("error");

  return useCallback(
    async (id: number, remark: string) => {
      // 接口文档：id 必填，remark 可不传/传空串表示清空
      const res = await request.post("/api/rendering/user/remarkSubUser", {
        id,
        remark,
      });
      if (res.code !== 200) {
        message.error(errorT(`error_${res.code}`));
        return;
      }
      if (isDingTalk) {
        fetchDingTalkSubAccountList({
          deptId,
          subUserId: isSearchSubUser ? id : undefined,
        });
        return;
      }
      fetchSubAccountList();
    },
    [
      isDingTalk,
      deptId,
      isSearchSubUser,
      fetchSubAccountList,
      fetchDingTalkSubAccountList,
      errorT,
    ]
  );
}
